import { getCSCId, post, setSessionGuid } from './api'
import { LOGIN_URL, LOGOUT_URL } from '../constants/urls'
import { Log } from '../utilities/logger'

export const login: any = async (CSCId: string) => {
  const response = await post(LOGIN_URL, CSCId)
  setSessionGuid(response.data.sessionGuid)
}
export const logout: any = () => async () => {
  try {
    const CSCId = getCSCId()
    if (CSCId) {
      await post(LOGOUT_URL, CSCId)
    }
  } catch (e) {
    Log('logout error', e)
  }
}
